import { render, staticRenderFns } from "./ABM.vue?vue&type=template&id=3885e18e&"
import script from "./ABM.vue?vue&type=script&lang=js&"
export * from "./ABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports